const borderRadius = {
    low: '0.4rem',
    medium: '0.8rem',
    mediumHigh: '1.2rem',
    high: '1.6rem',
    highM: '2rem',
    highL: '7.2rem',
    highest: '50%',
};
export default borderRadius;
//# sourceMappingURL=borderRadius.js.map